import {
  ContactsData,
  OrderStatus,
  ProductsLocalization,
  PurchaseOrder,
  PurchaseProduct,
} from 'data/interfaces/Common';
import { PromoCodeResponseDto } from '@arbihunter/api-client';
import { Dispatch, SetStateAction, createContext, useContext, useMemo, useState } from 'react';
import { ProductType } from 'types/enums';

interface IState {
  setProducts: Dispatch<SetStateAction<PurchaseProduct[]>>;
  products: PurchaseProduct[];
  cvContractsProducts: PurchaseProduct[];
  orders: PurchaseOrder[];
  setOrders: Dispatch<SetStateAction<PurchaseOrder[]>>;
  contacts: ContactsData;
  setContacts: Dispatch<SetStateAction<ContactsData>>;
  localization: ProductsLocalization[];
  setLocalization: Dispatch<SetStateAction<ProductsLocalization[]>>;
  promoCodes: PromoCodeResponseDto[];
  setPromoCodes: Dispatch<SetStateAction<PromoCodeResponseDto[]>>;
  lastPartialPayedOrder?: PurchaseOrder;
}

const TariffContext = createContext<Partial<IState>>({});

interface Props {
  children: React.ReactNode;
  orders?: PurchaseOrder[];
}

export function TariffWrapper(props: Props) {
  const [products, setProducts] = useState<PurchaseProduct[]>([]);
  const [orders, setOrders] = useState<PurchaseOrder[]>(props.orders ?? []);
  const [contacts, setContacts] = useState<ContactsData | null>(null);
  const [localization, setLocalization] = useState<ProductsLocalization[]>([]);
  const [promoCodes, setPromoCodes] = useState<PromoCodeResponseDto[]>([]);

  const lastPartialPayedOrder = useMemo(() => {
    return orders.find(
      (order) => order.paymentTransactions !== null && order.status === OrderStatus.PARTIAL_PAYMENT,
    );
  }, [orders]);

  const value: IState = {
    setProducts,
    products,
    orders,
    setOrders,
    contacts,
    setContacts,
    localization,
    setLocalization,
    promoCodes,
    setPromoCodes,
    lastPartialPayedOrder,
    cvContractsProducts: products.filter(
      (product) => product.contents?.type === ProductType.CV_CONTACTS_OPEN,
    ),
  };

  return <TariffContext.Provider value={value}>{props.children}</TariffContext.Provider>;
}

export function useTariffContext() {
  return useContext(TariffContext);
}
